import { render, staticRenderFns } from "./AddGolaPlan.vue?vue&type=template&id=7f9d90be&scoped=true"
import script from "./AddGolaPlan.vue?vue&type=script&lang=js"
export * from "./AddGolaPlan.vue?vue&type=script&lang=js"
import style0 from "./AddGolaPlan.vue?vue&type=style&index=0&id=7f9d90be&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f9d90be",
  null
  
)

export default component.exports